import React from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'
import Pressable from '../../common/Pressable/Pressable'

import styles from './FreeGiftBuoy.module.css'

const FreeGiftBuoy = withPlugin(props => {
  return (
    <div className={styles.wrapper}>
      <Pressable className={styles.image} onClick={props.onClick} ariaLabel={props.$i18n.transl('core.promotion.freeGift.freeGiftViewOffer')} />
      <Pressable className={styles.close} onClick={props.onClose} ariaLabel={props.$i18n.transl('common.close')}><span aria-hidden="true">&#xe60e;</span></Pressable>
    </div>
  )
})

export default FreeGiftBuoy